import {Box} from "@mui/material";
import {envBannerHeight} from "../../theme";

const StageBanner = () => {
  const env = process.env.REACT_APP_ENV;

  if (env === 'production' || envBannerHeight === 0) {
    return null;
  }

  const label = env === 'stage'
    ? 'STAGING ENVIRONMENT — NOT PRODUCTION'
    : 'LOCAL / DEV ENVIRONMENT — NOT PRODUCTION';

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: `${envBannerHeight}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: '#d32f2f',
        color: '#fff',
        textAlign: 'center',
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: 1,
        pointerEvents: 'none',
      }}
    >
      {label}
    </Box>
  );
};

export default StageBanner;
